export default __webpack_public_path__ + "static/poweredby-4-0df83336322b0dba4e81cbf88f3743dd.jpg";